export const If = ({ children, condition }) => (condition ? children : null);
export const IfElse = ({ children, condition }) => (condition ? children[0] : children[1]);
